var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M1 1h10M1 7h13M1 13h17","key":1})]);
}

Menu.defaultProps = {"fill":"none","viewBox":"0 0 19 14"};

module.exports = Menu;

Menu.default = Menu;
